import React, { useEffect } from 'react';
import Layout from '../components/layout/Layout';
import { usePagesServiceGetPages } from '../openapi/queries';
import './Pages.scss';
import Markdown from '../components/layout/elements/Markdown';

const HelpCenterPage: React.FC = () => {
    const {data:helpContent} = usePagesServiceGetPages({name: 'helpcenter'});
    const {data:contactContent} = usePagesServiceGetPages({name: 'contact'});
    
    useEffect(() => {
        let url = window.location.hash;
        let target = url.substring(1).toLowerCase();
        let element = document.getElementById(target);
        element && element.scrollIntoView({ behavior: "smooth", block: "start"});
    }, [helpContent]);

    return (<Layout className='help-center'>
        <div className='page-wrapper'>
            <Markdown content={helpContent?.content} />
        </div>
        <div className='page-wrapper sticky'>
            <Markdown content={contactContent?.content} />
        </div>
    </Layout>)
};

export default HelpCenterPage;